import * as React from 'react';
import { Nav, Row, Col } from 'react-bootstrap';
import { TempChart } from './temp_chart';

export const TempTab: React.FC = (): React.ReactElement => {
  const [selectedTab, selectTab] = React.useState('#outside');
  const styles = {
    row: {
      paddingTop: '15px',
    },
    navCol: {
      paddingBottom: '15px',
    },
  };
  return (
    <Row className="justify-content-center" style={styles.row}>
      <Col md="auto" className="text-center pt-3" style={styles.navCol}>
        <Nav
          variant="pills"
          className="flex-column"
          defaultActiveKey="#outside"
          onSelect={(event) => selectTab(event!)}
        >
          <Nav.Item>
            <Nav.Link eventKey="#outside">Väljas</Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link eventKey="#boiler">Boiler</Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link eventKey="#tuba">Tuba</Nav.Link>
          </Nav.Item>
        </Nav>
      </Col>
      <Col md="auto">
        <TempChart selectedTab={selectedTab} />
      </Col>
    </Row>
  );
};
